import { type FC } from 'react'
import { Spinner } from '../../../../components/Spinner/Spinner'
import { useSchedulingTemplatesEnabled } from '../../../Scheduling/shared/useSchedulingTemplatesEnabled'
import { LegacyRemindersSection, type RemindersSectionProps } from './LegacyRemindersSection'
import { RemindersSetupSection } from './Reminders/RemindersSetupSection'

export const RemindersSection: FC<RemindersSectionProps> = (props) => {
  const { isEnabled, isLoading } = useSchedulingTemplatesEnabled()

  if (isLoading) {
    return (
      <div className='d-flex justify-content-center py-5'>
        <Spinner />
      </div>
    )
  }

  return isEnabled ? (
    <RemindersSetupSection readOnly={props.readOnly} smsChannel={props.smsChannel} onShowTextMessages={props.onShowTextMessages} />
  ) : (
    <LegacyRemindersSection {...props} />
  )
}
